import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import language from '../../../js/stores/language.js';
import carLoanRating from '../../../js/stores/car-loan-rating.js';

//Create custom component to export
var RatingForm = function RatingForm(props, _ref) {
  var $h = _ref.$h,
    $f7 = _ref.$f7,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted;
  var locale = language.getters.Item.value;
  var textEditor = null;
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          setTimeout(function () {
            configEditor();
          }, 250);
          $update();
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  var configEditor = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            textEditor = $f7.textEditor.create({
              el: '#userComments',
              buttons: [],
              placeholder: locale.translate('loan.rating.textPlaceHolder')
            });
            $update();
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function configEditor() {
      return _ref3.apply(this, arguments);
    };
  }();
  var saveLoanRate = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
      var checkedRadio, rating, feedback, formData, result;
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            event.preventDefault();
            checkedRadio = document.querySelector('input[name="rating"]:checked');
            if (!(checkedRadio == null)) {
              _context3.next = 1;
              break;
            }
            $f7.toast.show({
              text: locale.translate('loan.rating.chooseStarMessage')
            });
            return _context3.abrupt("return");
          case 1:
            if (!(textEditor.value == "")) {
              _context3.next = 2;
              break;
            }
            $f7.toast.show({
              text: locale.translate('loan.rating.editorMessage')
            });
            return _context3.abrupt("return");
          case 2:
            rating = checkedRadio.value;
            feedback = textEditor.value;
            formData = new FormData();
            formData.append("LoanRating", rating);
            formData.append("LoanComments", feedback);
            formData.append("CarLoanId", props.data.CarLoanData.CarLoanId);
            formData.append("CarId", props.data.CarMainData.CarId);
            formData.append("LenderId", props.data.CarMainData.ContactId);
            formData.append("BorrowerId", props.data.CarLoanData.BorrowerId);
            console.log("Rating: ", rating);
            console.log("Feedback: ", feedback);
            _context3.next = 3;
            return carLoanRating.dispatch(props.action, formData);
          case 3:
            result = _context3.sent;
            if (!(result.status !== undefined && result.status !== 201)) {
              _context3.next = 4;
              break;
            }
            $f7.toast.show({
              text: result.data.messages.error
            });
            return _context3.abrupt("return");
          case 4:
            $f7.toast.show({
              text: locale.translate('loan.rating.afterSaveMessage')
            });
            $f7.views.main.router.navigate('/', {
              reloadCurrent: true,
              ignoreCache: true
            });
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function saveLoanRate(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div>
  <form id="rating-form">
    <div class="block-title">${locale.translate('loan.rating.yourRatingLabel')}:</div>
    <div class="rating justify-content-center">
      <!-- Notice that the stars are in reverse order -->
      <input type="radio" id="star5" name="rating" value="5" />
      <label for="star5"><i class="icon material-symbols-rounded">star_rate</i></label>
      <input type="radio" id="star4" name="rating" value="4" />
      <label for="star4"><i class="icon material-symbols-rounded">star_rate</i></label>
      <input type="radio" id="star3" name="rating" value="3" />
      <label for="star3"><i class="icon material-symbols-rounded">star_rate</i></label>
      <input type="radio" id="star2" name="rating" value="2" />
      <label for="star2"><i class="icon material-symbols-rounded">star_rate</i></label>
      <input type="radio" id="star1" name="rating" value="1" />
      <label for="star1"><i class="icon material-symbols-rounded">star_rate</i></label>
    </div>
    <div class="block-title">${locale.translate('loan.rating.yourFeedbackLabel')}:</div>
    <div id="userComments" class="text-editor">
      <div class="text-editor-content" contenteditable></div>
    </div>
    <div class="block block-strong inset">
      <p class="grid grid-cols-3 xlarge-grid-cols-3">
        <div></div>
        <div>
          <a class="button button-fill button-small" href="#" @click="${saveLoanRate}">${locale.translate('loan.rating.sendFeedback')}</a>
        </div>
        <div></div>
      </p>
    </div>
  </form>
</div>
`
    }
    ;
};
//Export component name
export default RatingForm;

//On template use:
//<${RatingForm} data="${props.data}" action="ratingLender" />